<template>
  <div class="container">

<div v-if="this.content && this.content.roles[0].id == 1" >

    <AdminDashboard :opGroup="this.content.roles[0].id"></AdminDashboard>

</div>

<div v-else-if="this.content && this.content.roles[0].id == 3">

  <CalidadDashboard :opGroup="this.content.roles[0].id"></CalidadDashboard>

</div>
<div v-else-if="this.content && this.content.roles[0].id == 4">

  <OrganizatorDashboard :opGroup="this.content.roles[0].id"></OrganizatorDashboard>

</div>

<div v-else-if="this.content  && this.content.roles[0].id == 6" >
 
  <FinanzasDashboard />

</div>
<div v-else-if="this.content  && this.content.roles[0].id == 7" >
 
 <MaqferDashboard />

</div> 

<div v-else-if="this.content" >
 

 <OperatorDashboard :opId="this.content.id" :opGroup="this.content.roles[0].id"></OperatorDashboard>  

</div>

    <!---

	  {{ content }}

    --->

    <!-- <div class="col-12 section_title"> INICIO ({{ this.group }})</div> -->

    <!--- admin panel --->

    <!-- <div class="">
      <AdminDashboard></AdminDashboard>
    </div> -->

    <!--- operator panel 
			<hr>

		<div class="">

			<OperatorDashboard></OperatorDashboard>

		</div>--->
  </div>
</template>

<script>
import EventBus from "@/AppEventBus";
import AdminDashboard from "./dashboards/AdminDashboard.vue";
import CalidadDashboard from "./dashboards/CalidadDashboard.vue";
import OperatorDashboard from "./dashboards/OperatorDashboard.vue";
import UserService from "../services/user.service";
import OrganizatorDashboard from "./dashboards/OrganizatorDashboard.vue";
import FinanzasDashboard from "./dashboards/FinanzasDashboard.vue";
import MaqferDashboard from "./dashboards/MaqferDashboard.vue";

export default {
  components: {
    AdminDashboard,
    OperatorDashboard,
    CalidadDashboard,
    OrganizatorDashboard,
    FinanzasDashboard,
    MaqferDashboard,
  },
  data() {
    return {
      group: "",
      content: null,
      lineData: {
        labels: ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL"],
        datasets: [
          {
            label: "Dato 1",
            data: [65, 59, 80, 81, 56, 55, 40],
            fill: false,
            backgroundColor: "#2f4860",
            borderColor: "#2f4860",
            tension: 0.4,
          },
          {
            label: "Dato 2",
            data: [28, 48, 40, 19, 86, 27, 90],
            fill: false,
            backgroundColor: "#00bb7e",
            borderColor: "#00bb7e",
            tension: 0.4,
          },
        ],
      },
      items: [
        { label: "Add New", icon: "pi pi-fw pi-plus" },
        { label: "Remove", icon: "pi pi-fw pi-minus" },
      ],
      lineOptions: null,
    };
  },
  productService: null,
  themeChangeListener: null,
  mounted() {


    UserService.getUserBoard().then(
      (response) => {

        console.log(response)
        this.content = response.data;
      },
      (error) => {
        this.content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );

    this.themeChangeListener = (event) => {
      if (event.dark) this.applyDarkTheme();
      else this.applyLightTheme();
    };
    EventBus.on("change-theme", this.themeChangeListener);

    if (this.isDarkTheme()) {
      this.applyDarkTheme();
    } else {
      this.applyLightTheme();
    }
  },
  beforeUnmount() {
    EventBus.off("change-theme", this.themeChangeListener);
  },
  created() {},
  methods: {
    formatCurrency(value) {
      return value.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },
    isDarkTheme() {
      return this.$appState.darkTheme === true;
    },
    applyLightTheme() {
      this.lineOptions = {
        plugins: {
          legend: {
            labels: {
              color: "#495057",
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: "#495057",
            },
            grid: {
              color: "#ebedef",
            },
          },
          y: {
            ticks: {
              color: "#495057",
            },
            grid: {
              color: "#ebedef",
            },
          },
        },
      };
    },
    applyDarkTheme() {
      this.lineOptions = {
        plugins: {
          legend: {
            labels: {
              color: "#ebedef",
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: "#ebedef",
            },
            grid: {
              color: "rgba(160, 167, 181, .3)",
            },
          },
          y: {
            ticks: {
              color: "#ebedef",
            },
            grid: {
              color: "rgba(160, 167, 181, .3)",
            },
          },
        },
      };
    },
  },
};
</script>